// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"16816947","115":"aacf1e9e","144":"3355f76e","245":"1d82ca29","330":"d725540d","391":"dd664ac3","426":"8412f5b5","584":"0cb0b75b","594":"6787e610","703":"e91220bd","848":"b45547e2","859":"a2983d35"}[chunkId] + ".chunk.js";
};